module.exports = __webpack_public_path__ + "static/media/piatto.872341b0.jpg";